// import Vue from 'vue'
import CryptoJS from 'crypto-js'
// import { v1 as uuidv1 } from 'uuid'
import { OssService } from './oss_service'
import { getAction, postAction } from '@/api/manage'

const fileExistanceUrl = `/doFileBackend/file/getFileBySHA1`
const signatureUrl = `/doFileBackend/file/getSignature`
const saveFileUrl = `/doMistServer/projectResource/saveProjectResource`
export interface IOSSFile {
  fileId: number
  fileSize: number
  fileSHA1: string
  fileAddress: string
  fileName: string
  fileType: string
  fileOssPath?: string
}
export enum EN_BUSINESS_CODE {
  INVALID = '',
  // 项目文件
  PROJECT_FILE = 'project',
  // 组织文件
  GROUP_FILE = 'group',
  // 模型树文件
  MODEL_TREE_FILE = 'designFileSolutionFile',
}

export enum EN_RESOURCE_CODE {
  /** 零件 */
  PART = 'part',
  /** 零件库 */
  PARTLIBRARY = 'partLibrary',
  /** 项目资源 */
  PROJECTPART = 'projectPart',
  /** 项目资源库 */
  PROJECTPARTLIBRARY = 'projectPartLibrary',
  // 用户
  USER = 'user',
}

class UploadFileImpl {
  /**
   * @deprecated
   * 这个函数附带了太强的业务不通用
   * 请改用uploadFile2
   * @param file
   * @param resourceCode
   * @param projectId
   * @param pid
   * @returns
   */
  public async uploadFile(
    file: File,
    resourceCode: EN_RESOURCE_CODE = EN_RESOURCE_CODE.PROJECTPART,
    projectId?: number,
    pid?: string
  ): Promise<IOSSFile> {
    // 上传文件为项目文件必须添加项目id
    if (resourceCode === EN_RESOURCE_CODE.PROJECTPART && !projectId) {
      throw new Error('项目文件缺失项目id')
    }
    const ossFileInfo = await this.uploadFile2(file)
    if (resourceCode === EN_RESOURCE_CODE.USER) {
      return ossFileInfo
    }
    const fileId = (await this._saveFile(
      resourceCode,
      ossFileInfo.fileAddress,
      ossFileInfo.fileSHA1,
      ossFileInfo.fileType,
      file.name,
      projectId,
      pid
    )) as number
    ossFileInfo.fileId = fileId
    return ossFileInfo
  }

  public async uploadFile2(file: File, path?: string): Promise<IOSSFile> {
    console.log(file, '[[[')
    // 上传文件为项目文件必须添加项目id
    const fileSize = file.size
    if (fileSize > 1024000000) {
      // 1000MiB
      throw new Error('文件超过1G')
    }

    // 切片生成sha1
    let sha1 = CryptoJS.algo.SHA1.create()
    const sliceSize = 10485760 // 10 MiB
    let start = 0
    const uint8Array = new Uint8Array(file.size)
    while (start < file.size) {
      // eslint-disable-next-line no-await-in-loop
      const slice: Uint8Array = await this._readSlice(file, start, sliceSize)
      const wordArray = CryptoJS.lib.WordArray.create(slice as any)
      sha1 = sha1.update(wordArray)
      uint8Array.set(slice, start)
      start += sliceSize
    }

    sha1.finalize()

    // 上传必须使用ArrayBuffer，效率更高。并且binaryString上传的图片无法打开。
    if (!uint8Array) {
      throw new Error('文件没有正确加载')
    }
    const sha1Result = (sha1 as any)._hash.toString()

    const fileTypeSplit = file.name.split('.')
    const fileType = fileTypeSplit.pop()
    if (fileTypeSplit.length < 1 || !fileType) {
      throw new Error('上传文件名格式不正确')
    }
    // 根据内容判断文件是否已存在
    const fileInfo = await this._checkIfExist(sha1Result)
    if (fileInfo) {
      const { fileSize, fileMd5: fileSHA1, fileAddress, fileOssPath } = fileInfo
      const fileName = file.name
      return {
        fileId: -1,
        fileSize,
        fileSHA1,
        fileAddress,
        fileName,
        fileType,
        fileOssPath,
      }
    }

    // 文件不存在需上传
    const fileName = `${sha1Result}.${fileType}`

    let uploadUrl, fileOssPath, mime

    if (path) {
      const {
        uploadUrl: url1,
        fileOssPath: url2,
        mime: mime1,
      } = await this._getSignaturePath(path, EN_BUSINESS_CODE.INVALID)
      uploadUrl = url1
      fileOssPath = url2
      mime = mime1
    } else {
      // 获取文件签名
      const {
        uploadUrl: url1,
        fileOssPath: url2,
        mime: mime1,
      } = await this._getSignature(fileName, EN_BUSINESS_CODE.INVALID)
      uploadUrl = url1
      fileOssPath = url2
      mime = mime1
    }

    // 压缩并上传到oss
    await OssService.uploadToOSS(uploadUrl, uint8Array, { 'content-type': mime }).catch((e) => {
      throw e
    })

    return {
      fileId: -1,
      fileSize: file.size,
      fileSHA1: sha1Result,
      fileAddress: fileOssPath,
      fileName,
      fileType,
    }
  }

  private async _readSlice(file: File, start: number, size: number): Promise<Uint8Array> {
    return new Promise<Uint8Array>((resolve, reject) => {
      const fileReader = new FileReader()
      const slice = file.slice(start, start + size)

      fileReader.onload = () => resolve(new Uint8Array(fileReader.result as any))
      fileReader.onerror = reject
      fileReader.readAsArrayBuffer(slice)
    })
  }

  // TODO: 目前另写了一套axios发送，后续axios封装统一后再改

  // 验证文件是否已存在
  private async _checkIfExist(fileSHA1: string) {
    const params = {
      fileSHA1,
    }

    const { data } = await getAction(`${window.ENV_CONFIG.baseUrl}${fileExistanceUrl}`, params)
    return data
  }

  private async _getSignature(fileName: string, businessCode: EN_BUSINESS_CODE) {
    const params = {
      fileName,
      businessCode,
    }
    const { data } = await getAction(`${window.ENV_CONFIG.baseUrl}${signatureUrl}`, params)
    return data
  }

  private async _getSignaturePath(fileOssPath: string, businessCode: EN_BUSINESS_CODE) {
    const params = {
      fileOssPath,
      businessCode,
    }
    const { data } = await getAction(`${window.ENV_CONFIG.baseUrl}${signatureUrl}`, params)
    return data
  }

  private async _saveFile(
    resourceCode: EN_RESOURCE_CODE,
    fileAddress: string,
    sha1: string,
    fileType: string,
    fileName: string,
    projectId?: number,
    pid?: string
  ) {
    const properties = {
      projectPart_type: 'part',
      projectPart_project_id: projectId,
      projectPart_is_root: true,
      projectPart_file_address: fileAddress,
      projectPart_file_type: fileType,
      projectPart_catia_file_sha1: sha1,
    }
    const params = {
      name: fileName,
      projectId,
      resourceCode,
      properties,
      type: 'file',
      pid,
    }

    const { data } = await postAction(`${window.ENV_CONFIG.baseUrl}${saveFileUrl}`, params)
    return data
  }
}

export const UploadFileService = new UploadFileImpl()
